// @flow

import React, { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import TextInput from './shared/TextInput';
import Message from './shared/Message';
import Wrapper from './shared/FormFieldWrapper';
import Button from './shared/Button';
import DropdownInput from './shared/DropdownInput';

import type { AddressFormInput } from '../models/AddressForm';
import type { FieldErrors } from '../types/form';

type Props = {
  address: AddressFormInput,
  errors: FieldErrors,
  cta?: string,
  onSubmit: (evt: Event) => void,
  onValueChange: (string, string) => void,
  isLoading: boolean,
  successMsg: string,
  btnIsSequential: boolean
} & WithTranslation

class AddressForm extends Component<Props> {
  onChange = (evt: SyntheticInputEvent):void => {
    this.props.onValueChange(evt.target.name, evt.target.value);
  }

  props: Props;

  render() {
    const { cta, t } = this.props;
    return (
      <div className='form-container'>
        <form onSubmit={this.props.onSubmit}>
          <TextInput
            label={t('street_addr')}
            placeholder={t('street_addr')}
            name='street_address'
            value={this.props.address.street_address}
            error={this.props.errors.street_address}
            onChange={this.onChange}
            required
          />
          <TextInput
            label={t('city')}
            placeholder={t('city')}
            name='city'
            value={this.props.address.city}
            error={this.props.errors.city}
            onChange={this.onChange}
            required
          />
          <DropdownInput
            label={t('province')}
            name='province'
            onChange={this.onChange}
            className='is-dropdown--large'
            value={this.props.address.province}
            selected={this.props.address.province}
            error={this.props.errors.province}
            edit
            province
            required
          />
          <TextInput
            label={t('postal_code')}
            placeholder={t('postal_code')}
            name='postal_code'
            value={this.props.address.postal_code}
            error={this.props.errors.postal_code}
            onChange={this.onChange}
            required
          />
          {this.props.successMsg ?
            <Wrapper>
              <Message className='is-success'>{this.props.successMsg}</Message>
            </Wrapper>
            : ''}
          <Button
            formSubmit
            className={`is-primary ${this.props.btnIsSequential ? 'is-sequential' : ''}`}
            label={cta || t('cta')}
            isLoading={this.props.isLoading}
          />
        </form>
      </div>
    );
  }
}

export default withTranslation('addressForm')(AddressForm);



// WEBPACK FOOTER //
// ./src/components/address-form.js